// extracted by mini-css-extract-plugin
export default {"form_input_wrapper":"styles_form_input_wrapper__o-rdv","date_input":"styles_date_input__d+wTd","image":"styles_image__BiUMg"};